import { render, staticRenderFns } from "./CheckboxAttribute.vue?vue&type=template&id=6fd63f94&scoped=true&"
import script from "./CheckboxAttribute.vue?vue&type=script&lang=js&"
export * from "./CheckboxAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd63f94",
  null
  
)

export default component.exports